import { useEffect, useState } from 'react';

import { EnumOption } from '../../../modules/types/types';
import httpClient from '../../httpClient';

type CidRegistro = {
  id: number;
  cid: string;
  descricao: string;
};

export const useCid = () => {
  const [cidOptions, setCidOptions] = useState<EnumOption[]>([]);
  const [descricaoOptions, setDescricaoOptions] = useState<EnumOption[]>([]);

  useEffect(() => {
    const fetchCidData = async () => {
      try {
        const response = await httpClient.get(`/api/cid`);

        const registros: CidRegistro[] = response.data ?? [];

        const cidOpts: EnumOption[] = [
          { value: '', label: 'Não informado' },
          ...registros.map((item) => ({
            value: item.id.toString(),
            label: item.cid,
          })),
        ];

        const descricaoOpts: EnumOption[] = [
          { value: '', label: 'Não informado' },
          ...registros.map((item) => ({
            value: item.id.toString(),
            label: item.descricao,
          })),
        ];

        setCidOptions(cidOpts);
        setDescricaoOptions(descricaoOpts);
      } catch (error) {
        console.error('Erro ao buscar CID-10', error);
      }
    };

    fetchCidData();
  }, []);

  return { cidOptions, descricaoOptions };
};
